<div class="d-flex flex-row justify-content-center align-items-center">
  <div class="options-to-display">
    <div class="option" *ngFor="let option of optionsToDisplay">
      <p class="mb-0 select-option-text" [innerText]="option"></p>
    </div>
  </div>
  <div *ngIf="restOptions.length > 0" class="options-other" [ngbTooltip]="restOptions.join(', ')">
    <p class="my-0 py-0 select-option-text" [innerText]="'+' + restOptions.length"></p>
  </div>
</div>
